import {MandarkResourceInterface} from '../Mandark.interface';

export class StudentIntervalStatsInterface extends MandarkResourceInterface {
  getIntervalData() {
    return this._data.getIn(['data', 'intervals']);
  }
}
